import { http, HttpResponse } from 'msw';

const authHandlers = [
  http.get('*/tokens', () =>
    HttpResponse.json({
      access_token:
        'RB8-8GsNkRidMeZ4H31BMTVOFM6bonDphVyKwFlKT48.-4AVHWViJRNPlyfimlmypoUcB_wQGBN9ZdzC246Tzic',
    })
  ),
  http.get('*/refresh', () =>
    HttpResponse.json({
      access_token:
        'RB8-8GsNkRidMeZ4H31BMTVOFM6bonDphVyKwFlKT48.-4AVHWViJRNPlyfimlmypoUcB_wQGBN9ZdzC246Tzic',
    })
  ),
  http.get('*/claims', () =>
    HttpResponse.json({
      is_user_migrated: true,
      sub: '94f5016b-c684-4141-8cef-cfd527a1d800',
      parent_guid: '94f5016b-c684-4141-8cef-cfd527a1d800',
    })
  ),
];

export default authHandlers;
